import type { AnchorHTMLAttributes, MouseEvent } from 'react';
import { irA } from './router';

interface PropsEnlace extends Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> {
  a: string;
}

// Es un <a> de verdad, así funcionan abrir en otra pestaña y copiar el enlace. El
// clic común pasa por irA para que volver() sepa que hubo una navegación propia.
export function Enlace({ a, onClick, children, ...resto }: PropsEnlace) {
  function alPulsar(evento: MouseEvent<HTMLAnchorElement>) {
    onClick?.(evento);
    if (evento.defaultPrevented || evento.button !== 0) return;
    if (evento.metaKey || evento.ctrlKey || evento.shiftKey || evento.altKey) return;
    evento.preventDefault();
    irA(a);
  }

  return <a href={`#${a}`} onClick={alPulsar} {...resto}>{children}</a>;
}
